import React from "react";
import { Server } from "../server";
import { Navigation } from "../router";

export const MainContext = React.createContext({ server: null as Server, navigation: null as Navigation });

MainContext.displayName = "DvMainContext";